import { Alert } from 'react-bootstrap'
import { ErrorBoundary } from 'react-error-boundary'

function FallbackRender({ error, resetErrorBoundary }) {
    return (
        <Alert variant="danger">
            <p>Something went wrong:</p>
            <pre style={{ color: 'red' }}>{error?.message}</pre>
        </Alert>
    )
}

export default function CustomizedErrorBoundary({ key, children }) {
    return (
        <>
            <ErrorBoundary key={key} FallbackComponent={FallbackRender}>
                {children}
            </ErrorBoundary>
        </>
    )
}
